import { getApiBase } from './config'

export type SessionTokenLimits = {
  maxMessages: number
  maxUserCharacters: number
}

export type SessionTokenResponse = {
  token: string
  expiresAt: string
  limits: SessionTokenLimits
  tenant: { id: string }
}

type RequestSessionOptions = {
  origin?: string
}

export async function requestSessionToken(
  portalKey: string,
  options: RequestSessionOptions = {}
): Promise<SessionTokenResponse> {
  console.info('[session] requesting token', {
    apiBase: getApiBase(),
    hasPortalKey: Boolean(portalKey),
    origin: options.origin,
  })
  const response = await fetch(`${getApiBase()}/session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Portal-Key': portalKey,
    },
    body: JSON.stringify({
      origin: options.origin,
    }),
  })

  if (!response.ok) {
    console.error(
      '[session] request failed',
      response.status,
      response.statusText
    )
    const text = await response.text()
    throw new Error(
      `Session request failed (${response.status}): ${
        text || response.statusText
      }`
    )
  }

  const data = (await response.json()) as SessionTokenResponse
  if (!data?.token || !data?.expiresAt) {
    console.error('[session] invalid response payload', data)
    throw new Error('Session response missing token or expiry.')
  }

  console.info('[session] token received', {
    tenant: data.tenant,
    expiresAt: data.expiresAt,
  })
  return data
}
